import React from "react"
import ReactDOM from "react-dom/client"
import "./main.scss"
import "./utils/normalize.css"
import { RouterProvider } from "react-router-dom"
import { router } from "./routes/routes"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
